import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const Breadcrumbs = ({ links, className = '' }) => {
  // if(!links || links.length < 2) return <div className='max-w-screen-lg bg-transparent mx-auto h-6 mb-2 whitespace-nowrap'/>; // if we want no breadcrumbs if only one link (like at the product list view)
  return (
    <div className={`bg-transparent flex flex-row mx-auto mb-6 ml-3 pr-10 md:ml-0 whitespace-nowrap text-base w-full overflow-hidden overflow-x-auto ${className}`}>
      {links?.map((link, i) => (
        <div className='' key={link.path + i}>
          {i < links.length - 1 ?
            <>
              <span className='pr-1'><Link className='text-neutral-ter no-underline hover:underline' to={link.path}>{link.display}</Link> </span>
              <span className='pr-2 text-neutral-sec'><i className='fa fa-chevron-right fa-xs' /></span>
            </>
            :
            <span className='pr-1 font-medium text-neutral-ter'>{link.display}</span>
          }
        </div>
      ))}
    </div>
  )
}

Breadcrumbs.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string
      , display: PropTypes.string.isRequired
    })
  ).isRequired
  , className: PropTypes.string
}

export default Breadcrumbs;